(function () {
  var bar = document.createElement('div');
  bar.className = 'bf-progress';
  bar.setAttribute('aria-hidden', 'true');

  function mount() {
    if (document.body) document.body.appendChild(bar);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }

  function start() {
    bar.classList.remove('bf-progress--done');
    bar.style.width = '0%';
    requestAnimationFrame(function () {
      bar.classList.add('bf-progress--active');
    });
  }

  window.addEventListener('pageshow', function () {
    bar.classList.remove('bf-progress--active');
    bar.style.width = '0%';
  });

  document.addEventListener(
    'click',
    function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      if (a.target === '_blank' || a.hasAttribute('download')) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      var url;
      try {
        url = new URL(a.href, window.location.href);
      } catch (err) {
        return;
      }
      if (url.origin !== window.location.origin) return;
      if (url.hash && url.pathname === window.location.pathname && url.search === window.location.search) return;
      start();
    },
    true
  );

  var forms = document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (form && form.tagName === 'FORM' && form.method && form.method.toLowerCase() === 'get') {
        start();
      }
    },
    true
  );
})();
